export default __webpack_public_path__ + "static/anatomy-8df1e0e7d3e40a53030b09ee6da9cec0.png";